import { Injectable, inject } from '@angular/core';
import { ApplicationService } from '../../application/shared/application.service';
import { LoadingService } from '../../shared/components/loading-bar/loading-bar.service';
import { TEXTOS_DESCARGA_SUPER_EJECUTIVO } from '../super-ejecutivo.constants';

/** Lo común de toda descarga del Super Ejecutivo: la barra de carga del layout mientras se arma y el aviso si falla. */
@Injectable({ providedIn: 'root' })
export class SuperEjecutivoDescargaService {
  private readonly app = inject(ApplicationService);
  private readonly barraDeCarga = inject(LoadingService);

  /** Arma y guarda un archivo con la barra de carga encendida; si falla, lo avisa con el snackbar de Kobra Admin. */
  public async descargar(armarArchivo: () => Promise<void>): Promise<void> {
    this.barraDeCarga.setLoading(true);

    try {
      await armarArchivo();
    } catch (error) {
      console.error(TEXTOS_DESCARGA_SUPER_EJECUTIVO.NO_DESCARGADA, error);
      this.app.showError(TEXTOS_DESCARGA_SUPER_EJECUTIVO.NO_DESCARGADA);
    } finally {
      this.barraDeCarga.setLoading(false);
    }
  }
}
